import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentDots } from '@fortawesome/free-solid-svg-icons';
import Button from './Button';
import { setShowVideoFeedbackModal } from '../../../store/interface';

const VideoFeedbackButton = () => {
  const dispatch = useDispatch();

  const onClick = () => {
    dispatch(setShowVideoFeedbackModal(true));
  };

  return (
    <Button
      label="Video Feedback"
      icon={<FontAwesomeIcon icon={faCommentDots} />}
      onClick={onClick}
    />
  );
};

export default VideoFeedbackButton;
